import { ActionsContainerStyled } from "./style";
import ContrastIcon from "@mui/icons-material/Contrast";
import { ActionButton } from "./ActionButton";
import { LibrasButton } from "./LibrasButton";

interface ActionsContainerProps {
  increaseFonts: () => void;
  decreaseFonts: () => void;
  toggleContrast: () => void;
  handleToggleVLibras: () => void;
  onActionClick: (action: () => void) => void;
  variant?: "desktop" | "mobile";
}

export const ActionsContainer = ({
  increaseFonts,
  decreaseFonts,
  toggleContrast,
  handleToggleVLibras,
  onActionClick,
  variant = "desktop",
}: ActionsContainerProps) => {
  return (
    <ActionsContainerStyled variant={variant}>
      <ActionButton
        onClick={() => onActionClick(increaseFonts)}
        variant={variant}
        ariaLabel="Aumentar fonte A+"
      >
        A+
      </ActionButton>
      <ActionButton
        onClick={() => onActionClick(decreaseFonts)}
        variant={variant}
        ariaLabel="Diminuir fonte A-"
      >
        A-
      </ActionButton>
      <ActionButton
        onClick={() => onActionClick(toggleContrast)}
        variant={variant}
        ariaLabel="Alternar contraste"
      >
        <ContrastIcon fontSize="small" />
      </ActionButton>
      <LibrasButton
        variant={variant}
        onClick={() => onActionClick(handleToggleVLibras)}
      />
    </ActionsContainerStyled>
  );
};
